import React from 'react';

import { Control } from 'react-hook-form';
import PhoneInputWithCountry from 'react-phone-number-input/react-hook-form';

import { styled, Box } from '@liscio/ui';

import { CountrySelect } from './components';
import { CountrySelectProps } from './components/CountrySelect/CountrySelect';
import TextFieldRef from '../../TextFieldRef/TextFieldRef';

export interface PhoneInputProps {
  control: Control<any>;
  name: string;
  disabled?: boolean;
}

const Container = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  width: '100%',
});

export const PhoneInput: React.FC<PhoneInputProps> = ({
  control,
  name,
  disabled,
}) => {
  return (
    <PhoneInputWithCountry
      defaultCountry="US"
      containerComponent={Container}
      name={name}
      control={control}
      countrySelectComponent={(
        props: JSX.IntrinsicAttributes & CountrySelectProps
      ) => <CountrySelect {...props} disabled={disabled} />}
      inputComponent={TextFieldRef}
      disabled={disabled}
    />
  );
};

export default PhoneInput;
